export { default as About } from "./About";
